import React from 'react';

import PropTypes from 'prop-types';
import { Box, Divider, Notification, StackView, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

import Table from './components/table';
import SectionHeading from '../sectionHeading';

const Addons = ({
  addonsList,
  contentfulError,
  viewType,
  addons,
  setAddons,
  total,
  setTotal
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: { addonHeading }
  } = localizedStrings;

  return (
    <>
      {contentfulError && (
        <Notification variant={{ validation: 'error' }}>
          Error fetching addons data from contentful
        </Notification>
      )}

      {!contentfulError && addonsList.length > 0 && (
        <>
          <StackView space={3}>
            <SectionHeading><Typography heading="h4" variant={{ size: 'h4' }} block>{addonHeading}</Typography></SectionHeading>
            <Table
              viewType={viewType}
              addons={addons}
              setAddons={setAddons}
              list={addonsList}
              total={total}
              setTotal={setTotal}
            />
          </StackView>
          <Divider space={3} variant={{ inverse: true }} />
        </>
      )}
    </>
  );
};

Addons.propTypes = {
  addonsList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  contentfulError: PropTypes.shape({}).isRequired,
  viewType: PropTypes.string.isRequired,
  addons: PropTypes.shape({}).isRequired,
  setAddons: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired
};

export default Addons;
